import React from 'react'
import UniversityDisciplines from '../../components/services/studyabroad/UniversityDisciplines'
import ContactSection from '../../components/ContactSection'


const StudyAbroadPage = () => {
  return (
   <main>
  <UniversityDisciplines/>
  <ContactSection/>
   </main>
  )
}

export default StudyAbroadPage
